import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { ArkUnitOfWork } from 'app/core/core.module';
import { BackgroundCheck } from 'app/core/model/entity-model';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import DataSource from 'devextreme/data/data_source';
import { BsModalService } from 'ngx-bootstrap/modal';
import { confirm, alert } from 'devextreme/ui/dialog';
import { Guid } from 'app/core/data/entities';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-background-checks',
    template: `
        <div class="page-content page-fill">
            <div class="flex-fill grid-fill">
                <dx-data-grid #grid [dataSource]="backgroundChecks" keyExpr="id" [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)">
                    <dxi-column dataField="person.lastName" caption="Last Name" cellTemplate="linkTemplate"></dxi-column>
                    <dxi-column dataField="person.firstName" caption="First Name"></dxi-column>
                    <dxi-column dataField="submittedLocal" caption="Submitted"></dxi-column>
                    <dxi-column dataField="receivedLocal" caption="Received"></dxi-column>
                    <dxi-column dataField="cleared" cellTemplate="clearedTemplate"></dxi-column>
                    <dxi-column dataField="person.lastSafeChurchTrainedLocal" caption="Last Trained"></dxi-column>
                    <dxi-column></dxi-column>

                    <div *dxTemplate="let cell of 'linkTemplate'">
                        <a [routerLink]="" (click)="edit(cell.data.id)">{{ cell.text || '(blank)' }}</a>
                    </div>
                    <div *dxTemplate="let cell of 'clearedTemplate'">
                        <div>{{ cell.data.cleared ? 'Yes' : cell.data.cleared === false ? 'No' : '' }}</div>
                    </div>

                    <div *dxTemplate="let data of 'toolbarButtons'" class="d-flex align-items-center">
                        <dx-form [formData]="filter" [colCount]="1" class="mb-3" style="max-width: 700px;">
                            <!-- <dxi-item
                                dataField="start"
                                [label]="{ text: 'Start' }"
                                [editorType]="'dxDateBox'"
                                [editorOptions]="{ type: 'date' }"
                            ></dxi-item>
                            <dxi-item
                                dataField="end"
                                [label]="{ text: 'End' }"
                                [editorType]="'dxDateBox'"
                                [editorOptions]="{ type: 'date' }"
                            ></dxi-item> -->
                            <dxi-item>
                                <div *dxTemplate>
                                    <!-- <dx-button text="Go" type="default" (onClick)="search()"></dx-button> -->
                                    <dx-button text="Add" type="success" class="ms-3" (onClick)="edit()"></dx-button>
                                    <dx-button text="Edit" type="default" class="ms-3" (onClick)="edit(grid.focusedRowKey)" [disabled]="!grid.focusedRowKey"></dx-button>
                                    <dx-button text="Delete" type="danger" class="ms-1" (onClick)="delete(grid.focusedRowKey)" [disabled]="!grid.focusedRowKey"></dx-button>
                                </div>
                            </dxi-item>
                        </dx-form>
                    </div>

                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-selection [mode]="'single'"></dxo-selection>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="background-checks-grid"></dxo-state-storing>
                    <dxo-search-panel [visible]="true"></dxo-search-panel>
                    <dxo-export [enabled]="true" [fileName]="'background-checks'" [allowExportSelectedData]="true"></dxo-export>
                </dx-data-grid>
            </div>
        </div>

        <ng-template #backgroundCheckModal>
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title pull-left">Background Check</h4>
                </div>
                <div class="modal-body">
                    <dx-form [formData]="selectedBackgroundCheck">
                        <dxi-item
                            dataField="personId"
                            [label]="{ text: 'Person' }"
                            editorType="dxSelectBox"
                            [isRequired]="true"
                            [editorOptions]="{ dataSource: peopleDS, valueExpr: 'id', displayExpr: 'name' }"
                        ></dxi-item>
                        <dxi-item dataField="submittedLocal" editorType="dxDateBox" [label]="{ text: 'Submitted' }"></dxi-item>
                        <dxi-item dataField="receivedLocal" editorType="dxDateBox" [label]="{ text: 'Received' }"></dxi-item>
                        <dxi-item
                            dataField="cleared"
                            [label]="{ text: 'Cleared' }"
                            editorType="dxSelectBox"
                            [editorOptions]="{
                                items: [
                                    { name: 'Yes', value: true },
                                    { name: 'No', value: false }
                                ],
                                valueExpr: 'value',
                                displayExpr: 'name'
                            }"
                        ></dxi-item>
                        <dxi-item [label]="{ text: 'Last Trained' }">
                            <div *dxTemplate>
                                <dx-date-box [(value)]="newLastTrainedDate" placeholder="leave blank to not update"></dx-date-box>
                            </div>
                        </dxi-item>
                        <!-- <dxi-item
                            dataField="lastSafeChurchTrained"
                            editorType="dxDateBox"
                            [label]="{ text: 'Last Trained' }"
                            [editorOptions]="{ placeholder: 'leave blank to not update' }"
                        ></dxi-item> -->
                    </dx-form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" (click)="saveDialog()">Save</button>
                    <button type="button" class="btn btn-default" (click)="closeDialog()">Cancel</button>
                </div>
            </div>
        </ng-template>
    `,
    styles: [],
    imports: [DevExtremeModule]
})
export class BackgroundChecksComponent implements OnInit {
    backgroundChecks: BackgroundCheck[];
    selectedBackgroundCheck: BackgroundCheck;
    newLastTrainedDate: Date;
    filter = { start: null, end: null };
    people: any[];
    peopleDS: DataSource;

    @ViewChild('backgroundCheckModal') backgroundCheckModal: TemplateRef<any>;

    constructor(private uow: ArkUnitOfWork, private modalService: BsModalService) {}

    async ngOnInit() {
        this.people = (await this.uow.getPeople()).map((p) => {
            return {
                id: p.id,
                name: `${p.firstName} ${p.lastName}`,
            };
        });
        this.peopleDS = new DataSource({
            store: this.people,
            paginate: true,
        });
        this.backgroundChecks = await this.uow.backgroundChecks.all('submitted desc', 'person');
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    // async search() {
    //     let query = this.uow.involvements.baseQuery();

    //     if (this.filter.start) query = query.where('submitted', '>=', this.filter.start);
    //     if (this.filter.end) query = query.where('submitted', '<=', this.filter.end);

    //     query = query
    //         .orderBy(['submitted desc', 'person.lastName', 'person.firstName'])
    //         .select(['id', 'when', 'person.firstName', 'person.lastName', 'skill.name']);

    //     this.involvements = (await this.uow.executeQuery(query)) as Involvement[];
    // }

    adding = false;
    async edit(id?: Guid) {
        this.newLastTrainedDate = null;
        this.selectedBackgroundCheck = id ? this.backgroundChecks.find((b) => b.id === id) : (this.uow.manager.createEntity('BackgroundCheck', {}) as BackgroundCheck);
        const modalRef = this.modalService.show(this.backgroundCheckModal, { backdrop: 'static', class: 'modal-sm', focus: true });
        this.modalService.onHidden.subscribe((reason) => {
            this.closeDialog();
        });
    }

    async saveDialog() {
        const adding = this.selectedBackgroundCheck.entityAspect.entityState.isAdded();

        if (this.newLastTrainedDate) {
            const person = await this.uow.people.byId(this.selectedBackgroundCheck.personId);
            person.lastSafeChurchTrainedLocal = this.newLastTrainedDate;
        }

        await this.uow.commit();
        // if (this.selectedBackgroundCheck.when) this.defaultWhen =  this.selectedInvolvement.when;

        if (adding) this.backgroundChecks.push(this.selectedBackgroundCheck);
        this.closeDialog();
    }

    closeDialog() {
        this.uow.rollback();
        this.modalService.hide(1);
    }

    async delete(id: Guid) {
        if (await confirm('Are you sure you want to delete this background check?', 'Delete?')) {
            const backgroundCheck = this.backgroundChecks.find((b) => b.id === id);
            backgroundCheck.entityAspect.setDeleted();
            this.uow.commit();
            // const backgroundChecks = this.backgroundChecks.slice(this.backgroundChecks.indexOf(backgroundCheck), 1);
            // this.backgroundChecks = null;
            this.backgroundChecks = this.backgroundChecks.filter((b) => !b.entityAspect.entityState.isDeleted());
        }
    }
}
